module.exports = require("plugin-liverig/shared/components/TooltipInfo");